import { useStore } from "../store/globalState";
import { AuraLayout, Layout } from "lola-framework-ui-test";
import { useNavigate } from "react-router-dom";
import { TITLE_COLOR, flavorClassName } from "../constants";
import { MailStrokeIcon, WhatsAppStrokeIcon } from "../assets/icons";
import { PayoutInfo } from "./transfer/flavor-a/components/PayoutInfo";
import { useSessionStore } from "../store/useSessionStore";
import { useTranslation } from "react-i18next";
import { useClaimLink } from "../hooks/useClaimLink";
import { useEffect, useState } from "react";
import { Toast } from "../components/Toast";
import { getEvents, safeCapture } from "../analytics";
import { Navbar } from "../components/Navbar";

export const SupportPageV2 = () => {
  useClaimLink();
  const [showToast, setShowToast] = useState(true);
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    safeCapture(getEvents().SUPPORT_VIEW);
  }, []);

  const goToWhatsApp = () => {
    const phone = session.data?.partner?.supportWhatsappNumber;
    if (!phone) return;
    const cleanPhone = phone.replace(/\D/g, "");
    const url = `https://wa.me/${cleanPhone}`;
    window.open(url, "_blank");
  };

  const sendEmail = async () => {
    const email = session.data?.partner?.supportEmail;
    if (!email) return;
    const mailto = `mailto:${email}${`?subject=""`}`;
    try {
      await navigator.clipboard.writeText(email);
      setShowToast(true);
    } catch (err) {
      console.warn("No se pudo copiar el email", err);
    }
    window.open(mailto, "_blank");
  };

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className={`white-view-background ${flavorClassName}`}
    >
      <Layout.Header>
        <Navbar
          onBackClick={() => navigate(-1)}
          title={t("contact.title")}
          align="center"
        />
      </Layout.Header>
      <Layout.Content>
        <section className="support-page-v2-container">
          <PayoutInfo
            title="Whatsapp"
            subtitle=""
            icon={<WhatsAppStrokeIcon size={24} className="bg-transparent " />}
            color={TITLE_COLOR}
            onChange={goToWhatsApp}
          />
          <PayoutInfo
            title="Email"
            subtitle=""
            icon={<MailStrokeIcon size={24} className="bg-transparent " />}
            color={TITLE_COLOR}
            onChange={sendEmail}
          />
        </section>
        <section className="toast-container">
          {showToast && (
            <Toast
              message="Email copiado al portapapeles"
              duration={2000}
              type="success"
              onClose={() => setShowToast(false)}
            />
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
